(() => {
  if (customElements.get('orialy-menu')) return;
  customElements.define('orialy-menu', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.details = this.querySelector('.orialy-mobile-disclosure');
      this.trigger = this.details?.querySelector(':scope > summary');
      this.closeButton = this.querySelector('.orialy-mobile-menu-close');
      if (!this.details || !this.trigger || !this.closeButton) return;
      this.closeButton.hidden = false;
      this.details.addEventListener('toggle', () => this.sync(), { signal });
      this.closeButton.addEventListener('click', () => this.close(), { signal });
      this.addEventListener('click', event => { if (event.target.closest('a')) this.close(); }, { signal });
      document.addEventListener('keydown', event => {
        if (!this.details.open) return;
        if (event.key === 'Escape') { event.preventDefault(); this.close(); }
        if (event.key !== 'Tab') return;
        const nodes = [...this.querySelectorAll('a,button,summary')].filter(node => node.getClientRects().length && !node.hidden);
        const first = nodes[0], last = nodes.at(-1);
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      }, { signal });
      this.media = matchMedia('(max-width: 900px)');
      this.media.addEventListener('change', () => { if (!this.media.matches) this.close(false); }, { signal });
      this.sync();
    }
    sync() {
      const open = this.details.open;
      this.trigger.setAttribute('aria-expanded', String(open));
      document.documentElement.classList.toggle('orialy-menu-open', open);
      if (open && !this.savedInert) {
        const nodes = [...document.querySelectorAll('#MainContent, .orialy-footer, .orialy-nav > a, .orialy-actions, .orialy-nav-links')];
        this.savedInert = nodes.map(node => [node, node.inert]);
        nodes.forEach(node => { node.inert = true; });
        this.closeButton.focus();
      } else if (!open) this.restore();
    }
    restore() { this.savedInert?.forEach(([node, value]) => { node.inert = value; }); this.savedInert = null; }
    close(focus = true) { this.details.open = false; this.sync(); if (focus) this.trigger.focus(); }
    disconnectedCallback() { this.controller?.abort(); this.restore(); document.documentElement.classList.remove('orialy-menu-open'); }
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.orialy-nav-links details[open]').forEach(node => { node.open = false; node.querySelector('summary')?.focus(); });
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.orialy-nav-links details[open]').forEach(node => { if (!node.contains(event.target)) node.open = false; });
  });
})();
